@use "foundation/colors";
@use "foundation/responsive";

.payment-info-form {
  max-width: 475px;

  strong {
    font-weight: 700;
  }

  @include responsive.tablet {
    margin: auto;
  }

  @include responsive.phone {
    width: 100%;
  }

  .price-container {
    display: flex;
    flex-direction: column;

    .price-list,
    .price-interval {
      display: flex;
      flex-direction: row;
      color: rgb(34 34 34 / 40%);
      font-size: 14px;
      gap: 12px;

      div {
        flex: 1;
        text-align: center;
      }
    }

    .price-list {
      div {
        padding: 28px 8px 20px;
        cursor: pointer;
        position: relative;
        border-radius: 12px;
        background-color: rgb(34 34 34 / 5%);
        border: 4px solid transparent;
        transition: background-color 0.25s ease-out, border-color 0.25s ease-out;

        &.selected-price {
          background-color: white;
          border-color: rgb(34 34 34 / 10%);

          .price-value {
            color: colors.$primary-eerie-black;
          }

          .price-period {
            color: rgb(34 34 34 / 60%);
          }
        }

        &:hover {
          .price-value,
          .price-period {
            color: colors.$primary-eerie-black;
          }
        }
      }

      .price-value {
        display: block;
        font-size: 32px;
        font-weight: 800;
        line-height: 1.1;

        &.full-price {
          color: colors.$neutrals-grey !important;
          text-decoration: line-through;
          font-size: 16px;
          line-height: 1em;
        }
      }

      .price-period {
        display: block;
        font-size: 14px;
        font-weight: 600;
        line-height: 1.3;
      }

      .price-discount {
        font-size: 12px;
        font-weight: 700;
        padding: 5px 7px;
        line-height: 1.3;
        color: white;
        background-color: #238a48;
        border-radius: 6px;
        position: absolute;
        top: 2px;
        right: 2px;
        white-space: nowrap;

        &.hidden {
          display: none;
        }
      }
    }

    .price-interval {
      div {
        font-weight: 600;
        opacity: 0;
      }

      .selected-interval {
        opacity: 1;
        transition: opacity 0.25s ease-out;

        span.full-price {
          text-decoration: line-through;
          font-size: 0.9em;
        }
      }
    }

    .price-annual-option {
      display: flex;
      flex-direction: column;
      background-color: colors.$neutrals-light-grey;
      border-radius: 0.85em;
      padding: 16px 20px;

      .title {
        font-weight: 700;
      }

      .price-value {
        font-weight: 900;
        font-size: 32px;
        margin: 4px 0;
      }

      .price-period {
        font-weight: 600;
        font-size: 14px;
        color: colors.$neutrals-dark-grey;
      }
    }
  }
}
